import { IJuniorShowmanshipResults, IScore } from "@eagerdog/interfaces";
import { Constants } from "@eagerdog/constants";

import { padPlacements, preferScores } from "./labels";

const LEVEL = Constants.dog_class_element_level;

/** Junior classes that get 1st–4th. */
export const JUNIOR_PLACEMENT_LEVELS: string[] = [
  LEVEL.pre_junior,
  LEVEL.novice_junior,
  LEVEL.open_junior,
  LEVEL.novice_senior,
  LEVEL.open_senior,
];

/** Classes whose handlers compete for Best Junior Handler (Pre-Junior does not). */
export const BEST_JUNIOR_LEVELS: string[] = [
  LEVEL.novice_junior,
  LEVEL.open_junior,
  LEVEL.novice_senior,
  LEVEL.open_senior,
];

/** Participation only: no placement grid. */
export const JUNIOR_PARTICIPATION_LEVELS: string[] = [LEVEL.pee_wee, LEVEL.sub_junior];

export function juniorScoresFor(scores: IScore[], level: string): IScore[] {
  return scores.filter((score) => score.dog_class?.level === level);
}

/** Placement classes present in this show, in rulebook order. */
export function juniorPlacementClasses(scores: IScore[]): string[] {
  return JUNIOR_PLACEMENT_LEVELS.filter((level) => juniorScoresFor(scores, level).length > 0);
}

export function juniorParticipationClasses(scores: IScore[]): string[] {
  return JUNIOR_PARTICIPATION_LEVELS.filter(
    (level) => juniorScoresFor(scores, level).length > 0
  );
}

/** Saved junior placements keyed by level, padded to four slots. */
export function readJuniorPlacements(
  saved: IJuniorShowmanshipResults | undefined,
  classes: string[]
): Record<string, string[]> {
  const map: Record<string, string[]> = {};
  classes.forEach((level) => {
    const row = saved?.class_results?.find((item) => item.level === level);
    map[level] = padPlacements(row?.placements);
  });
  return map;
}

/** Best Junior Handler pool: the four licensed classes, saved 1sts first. */
export function bestJuniorPool(
  scores: IScore[],
  placementsByLevel: Record<string, string[]>
): IScore[] {
  const pool = scores.filter((score) =>
    BEST_JUNIOR_LEVELS.includes(score.dog_class?.level || "")
  );
  const firsts = BEST_JUNIOR_LEVELS.map((level) => placementsByLevel[level]?.[0]).filter(
    (id): id is string => !!id
  );
  return preferScores(pool, firsts, { junior: true });
}
